import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { MapAndSetInterpolationService } from './map-and-set-interpolation.service';
import { FullTemplateInfo, BlueprintBase, CoverBlueprint } from './models/blueprint.model';
import { TemplateFieldsCatalog } from './models/template.model';
import { ReportExportViewService } from './report-export-view.service';

@Injectable()
export class ReportBluePrintInterpolationService {
  constructor(
    private reportExportViewService: ReportExportViewService,
    private mapAndSetInterpolationService: MapAndSetInterpolationService
  ) {}

  blueprintInterpolation(
    catalogUri: string,
    templateId: number,
    reportDataEntity: string,
    locale: number,
    columns: { [entity: string]: { [columnField: string]: any } }
  ): Observable<any> {
    const blueprint$ = this.reportExportViewService.getBaseBlueprintByTemplateId(templateId, reportDataEntity, locale);
    const templateCatalog$ = this.reportExportViewService.getTemplateFieldsCatalog(catalogUri, templateId, locale);
    return forkJoin([blueprint$, templateCatalog$]).pipe(
      take(1),
      switchMap(partialTemplateInfo => this.getFullTemplateInfo(partialTemplateInfo)),
      switchMap((fullTemplateInfo: FullTemplateInfo) => {
        this.mapAndSetInterpolationService.mapAndSet(templateId, reportDataEntity, fullTemplateInfo, columns, locale);
        return of(templateId);
      })
    );
  }

  /**
   * Get and map all the data needed for the report, including the cover,
   * the blueprint and template fields data.
   *
   * @param partialTemplateInfo
   */
  private getFullTemplateInfo(
    partialTemplateInfo: [BlueprintBase, TemplateFieldsCatalog]
  ): Observable<FullTemplateInfo> {
    const [blueprint, templateCatalog] = partialTemplateInfo;
    let coverSlideInfo$: Observable<CoverBlueprint> = of(null);
    // verify that cover path exists
    if (blueprint.coverPath != null) {
      coverSlideInfo$ = this.reportExportViewService.getCoverPageBluePrint(blueprint.coverPath);
    }
    return coverSlideInfo$.pipe(
      // map to FullTemplateInfo
      map(coverSlideInfo => {
        return { coverSlideInfo, blueprint, templateCatalog };
      })
    );
  }
}
